import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PetitionerDashboardRoutingModule } from "./dashboard-petitioner-routing.module";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCardModule } from "@angular/material/card";
import { DashboardPetitionerComponent } from "./dashboard-petitioner.component";
import { PetitionerWelcomeDialog } from "./dashboard-petitioner.component";
import { DashboardModule } from "../dashboard/dashboard.module";
import { CarouselModule } from "ngx-owl-carousel-o";
import { MatDialogModule} from '@angular/material/dialog';
import { MatIconModule} from '@angular/material/icon';
import { JoyrideModule } from 'ngx-joyride'
import { SchedulingModule } from "../scheduling/scheduling.module";
import { PrimengLibraryModule } from 'primeng-library';
import { CardModule } from 'primeng/card';

@NgModule({
  declarations: [DashboardPetitionerComponent,
    PetitionerWelcomeDialog],
  imports: [
    CommonModule,
    PetitionerDashboardRoutingModule,
    PrimengLibraryModule,
    MatToolbarModule,
    MatCardModule,
    CardModule,
    CarouselModule,
    DashboardModule,
    MatDialogModule,
    MatIconModule,
    JoyrideModule.forChild(),
    SchedulingModule,
  ],
  bootstrap: [],
  entryComponents: [PetitionerWelcomeDialog]
})
export class PetitionerDashboardModule {}
